import styled from 'styled-components';

export const StyledControlBar = styled.div`
  background-color: #fbfbfb;
  align-items: center;
  display: flex;
  box-shadow: 0px 4px 6px rgba(200, 200, 200, 0.25);
  height: 40px;
  justify-content: space-between;
  padding: 0 1.125em;
  position: relative;
  max-height: 40px;
  min-height: 40px;
  z-index: 8000;

  & button {
    color: #4f4f4f;
  }
`;

export const LeftPanel = styled.div`
  display: flex;
  align-items: center;
`;

export const RightPanel = styled.div`
  display: flex;
  align-items: center;

  & > *:not(:first-child) {
    margin-left: 1.25em;
  }
`;
